<template>
  <a v-if="visible" :class="{ disabled }" :href="href" download @click.prevent="onDownload">
    <slot name="default">
      <v-btn icon>
        <v-icon color="primary" size="18"> mdi-download </v-icon>
      </v-btn>
    </slot>
  </a>
</template>

<script>
import { mapActions } from 'pinia';
import downloadFileUtils from '@/utils/download-file-utils';
import { useFilesStore } from '@/stores/files';
import { toApiUrl } from '@/utils/api-url';

export default {
  props: {
    url: {
      type: String,
      required: false,
      default: null,
    },

    filename: {
      type: String,
      required: false,
      default: null,
    },

    visible: {
      type: Boolean,
      required: false,
      default: true,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    href() {
      return toApiUrl(this.url);
    },
  },

  methods: {
    ...mapActions(useFilesStore, ['getDownloadToken']),

    async onDownload() {
      const downloadToken = await this.getDownloadToken();
      const fileData = {
        fileUrl: this.url,
        fileName: this.filename,
      };
      downloadFileUtils.handleDownload(downloadToken, fileData);
    },
  },
};
</script>

<style scoped lang="scss">
.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
